<template>
    <div>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-12">
                        <h3 class="mb-0">ขนส่งที่ตัวแทนจำหน่ายมี</h3>
                    </div>
                </div>
            </div>
            <div class="col-12 box-select-courier">
                <h6 class="mb-0 text-muted d-flex justify-content-center" v-if="agentCourier.length < 1">ยังไม่มีขนส่งที่ถูกสร้าง</h6>
                <div v-for="(courier , index) in agentCourier" :key="courier.id">
                    {{index+1}}.) {{courier.name}}
                    <label class="text-muted">Description: {{courier.description}}</label>
                </div>
            </div>
        </card>
    </div>
</template>

<script>

export default {
    data(){
        return {
            agentCourier: []
        }
    }
}
</script>